import { render, staticRenderFns } from "./DishDescription.vue?vue&type=template&id=8d9ce9ba"
import script from "./DishDescription.vue?vue&type=script&lang=js"
export * from "./DishDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports